import script from "./transactionComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./transactionComplete.vue?vue&type=script&setup=true&lang=js"

import "./transactionComplete.vue?vue&type=style&index=0&id=45d6f3e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d6f3e1"]])

export default __exports__